module.exports = __webpack_public_path__ + "img/logo-text-powered.5a978056.svg";